import React from "react";
import { Outlet } from "react-router-dom";
import PublicRoute from "../../components/auth/PublicRoute";
const AuthLayout = () => {
    return (React.createElement(PublicRoute, null,
        React.createElement(Outlet, null)));
};
export default AuthLayout;
